// biome-ignore lint/style/useImportType: keeping value import for compatibility
import * as React from 'react';
import { type FC, useCallback } from 'react';

import { useTranslation } from '@crehana/i18n';

// biome-ignore lint/style/useImportType: legacy import, will be migrated
import { TKeys } from '../../../../../i18n/types';
// biome-ignore lint/style/useImportType: legacy import, will be migrated
import InputField, { InputState } from '../InputField';
// biome-ignore lint/style/useImportType: legacy import, will be migrated
import { Validation } from '../InputField/types';
import { NameMask } from '../InputField/utils/NameMask';
// biome-ignore lint/style/useImportType: legacy import, will be migrated
import { NameState } from './types';

type Props = {
  onChange: (value: NameState) => void;
  isLastName?: boolean;
  required?: boolean;
  value?: string;
  placeholder?: string;
};

const mask = new NameMask();

const NameInput: FC<React.PropsWithChildren<Props>> = ({
  onChange,
  required,
  value,
  isLastName = false,
  placeholder,
}) => {
  const { t } = useTranslation<TKeys>();

  const handleOnChange = ({ maskedValue, isValid }: InputState) => {
    onChange({
      name: maskedValue,
      isValid,
    });
  };

  const label = isLastName ? 'LAST_NAME' : 'NAME';

  const validation: Validation = useCallback(
    ({ maskedValue }) => {
      // biome-ignore lint/style/useBlockStatements: single-line early return
      if (maskedValue.length === 0)
        return { isValid: false, errorMessage: t(`REQUIRED_${label}`) };
      // biome-ignore lint/style/useBlockStatements: single-line early return
      if (maskedValue.length < 3)
        return { isValid: false, errorMessage: t(`INVALID_${label}`) };
      return { isValid: true, errorMessage: '' };
    },
    [t, label],
  );

  return (
    <div className="mb-24">
      <InputField
        onChange={handleOnChange}
        label={t(`${label}_LABEL`)}
        validation={validation}
        required={required}
        value={value}
        mask={mask}
        placeholder={placeholder}
        darkMode
      />
    </div>
  );
};

export default NameInput;
